import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "list-info-in-count__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classContainer)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["title-block-top", { 'title-block-top_mini': _ctx.miniIndentation }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['title-block-top__first', { 'title-block-top__first--dense': _ctx.dense }, _ctx.classTitleBlock])
      }, [
        _createElementVNode("h2", {
          class: _normalizeClass(['title', 'title--h2', 'title--analytics-detail', { 'title-block-top__first--dense': _ctx.dense }])
        }, _toDisplayString(_ctx.title), 3),
        (_ctx.subtitle || _ctx.subtitleNumber || _ctx.$slots.subtitles)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['list-info-in-count', _ctx.classListInfo])
            }, [
              _renderSlot(_ctx.$slots, "subtitles", {}, () => [
                _createElementVNode("ul", _hoisted_1, [
                  _createElementVNode("li", null, [
                    _createTextVNode(_toDisplayString(_ctx.subtitle), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.subtitleNumber), 1)
                  ])
                ])
              ], true)
            ], 2))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.$slots.button)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["title-block-top__second", { 'title-block-top__second--dense': _ctx.dense }])
          }, [
            _renderSlot(_ctx.$slots, "button", {}, undefined, true)
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}